<mat-card >
    <mat-card-title class="font-weight-bold caption-color">Contract Datail</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">        
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                        Service Contract Period <span class="font-red-flamingo">(In Months)</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" name="txtMachineLife"  (input)="MachineLifeChange()"  [(ngModel)]="SpraRentalAmcvModel.MachineLife">
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                        Cont. Period <span class="font-red-flamingo">(In Months)</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number"  name="txtContPeriod" [(ngModel)]="SpraRentalAmcvModel.ContPeriod">
                        </div>
                    </div>

                </div>
            </div>

            
          
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                        Lock <span class="font-red-flamingo">(In Months)</span>
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" (input)="SetLeaseType()" type="number" name="txtLockInMonths" [(ngModel)]="SpraRentalAmcvModel.LockInMonths" >
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                       Security Deposite 
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" name="txtSecurityDeposite" [(ngModel)]="SpraRentalAmcvModel.SecurityDeposite" >
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                      Total Monthly Rent
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" [disabled]="SpraRentalAmcvModel.NotionalRent" name="txtMonthlyRent" [(ngModel)]="SpraRentalAmcvModel.MonthlyRent" >
                        </div>
                    </div>

                </div>
            </div>



            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label class="col-sm-4 col-form-label">
                      Notional Rent
                    </label>
                    <div class="col-sm-8">
                        <div class="input-group row mt-2">                            
                            <h4 class="col-sm-8">
                                <mat-checkbox color="primary" #chkNotionalRent [(ngModel)]="SpraRentalAmcvModel.NotionalRent" (change)="chkNotionalClick()"  >                                
                                </mat-checkbox>
                            <span *ngIf="SpraRentalAmcvModel.NotionalRent" class="floating badge badge-pill badge-primary ml-5" (click)="EnterNotionalRentDetail()"> Enter Notional Rent Detail </span>
                            </h4>
                        </div>
                    </div>

                </div>
            </div>


            <div class="col-sm-6">
                <div class="form-group row text-left">
                    <label for="lblLeaseType" class="col-sm-4 col-form-label">Lease Type</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <select id="ddlLeaseType" name="ddlPriceRefType" class="form-control" [(ngModel)]="SpraRentalAmcvModel.LeaseType" >
                                <option value="Finance Lease">Finance Lease</option>
                                <option value="Operating Lease">Operating Lease </option>
                            </select>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-sm-6" *ngIf="ProfitTag">
                <div class="form-group row text-left">
                    <label for="lblInterestRate" class="col-sm-4 col-form-label">Rate Of Interest</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" name="txtInterestRate" [(ngModel)]="SpraRentalAmcvModel.RateOfInterest" >
                        </div>
                        
                    </div>
                </div>
            </div>


            <div class="col-sm-6" *ngIf="ProfitTag">
                <div class="form-group row text-left">
                    <label for="lblResidualValue" class="col-sm-4 col-form-label">Residual Value</label>
                    <div class="col-sm-8">
                        <div class="input-group">
                            <input class="form-control" type="number" name="txtResidualValue" [(ngModel)]="SpraRentalAmcvModel.ResidualValue" >
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-sm-12" *ngIf="SpraRentalAmcvModel.CounterDetail.length>0">
                <table class="table ">
                    <thead>
                        <tr>
                            <th> Copy</th>
                            <th *ngIf="SaleType=='DD'" > Existing AMCV </th>
                            <th> Existing CSA Rate	 </th>
                            <th> Agreed CSA Rate (Rs per copy)</th>
                            <th> Customer Commitment Copy Per Month	 </th>
                            <th> Agreed Free Copy Per Month	</th>
                            <th> Estimated Monthly Copy Load </th>                            
                            <th> Total Copy </th>  
                            <th *ngIf="ProfitTag"> Std CSA Rate(Rs per copy)</th>
                            <th *ngIf="ProfitTag"> CSA Cost Rate(Rs per copy)</th>
                            <th *ngIf="ProfitTag"> CSA GP(%)(Rs per copy)</th>  

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of SpraRentalAmcvModel.CounterDetail; let i = index;">
                            

                            <td>
                                 {{item.CounterDesc}} 
                                  <!-- ~ {{item.Qty}} -->
                                 <!-- ===={{item.Qty}}
                                <span *ngFor="let item1 of item.ProductList; let i = index;">
                                    {{item1}}
                                </span> -->
                            </td>
                            <td *ngIf="SaleType=='DD'">
                                {{item?.ExistingAMCV}}
                            </td>
                            <td>
                                {{item.ExistingCSARate!=""?item.ExistingCSARate:"NA"}}
                            </td>
                            <td>
                                <input name="txtAgreedCSARate"  type="number" [(ngModel)]="item.AgreedCSARate" class="form-control">
                            </td>
                            <td>
                                <input name="txtCustomerCommitmentCopyL" type="number" [disabled]="SpraRentalAmcvModel.NotionalRent" [(ngModel)]="item.CustomerCommitmentCopy" class="form-control">
                            </td>
                            <td>
                                <input name="txtAgreedFreeCopy"  type="number" [disabled]="SpraRentalAmcvModel.NotionalRent" [(ngModel)]="item.AgreedFreeCopy" class="form-control" (change)="RecalculateServiceRevenue()">
                            </td>
                            <td>
                                <input name="txtEMCL" (input)="EmclChange(item)" type="number"  [disabled]="item.IsA3RatioEntered" [(ngModel)]="item.EMCL" class="form-control">                                
                            </td>
                            <td  class="text-right">
                                {{item?.TotalCopy | number : '1.2-2'}}
                            </td>      
                            <td *ngIf="ProfitTag" class="text-right">
                                {{item?.StdCSARate | number : '1.2-2'}}
                            </td>      
                            <td *ngIf="ProfitTag" class="text-right">
                                {{item?.CSACostRate | number : '1.2-2'}}
                            </td>      
                            <td *ngIf="ProfitTag" class="text-right"> 
                                {{item?.CSAGP | number : '1.2-2' }}%
                            </td>                            
                        </tr>
                        <tr *ngIf="ProfitTag" class="bg-highlight">
                            
                            <td colspan="4">
                                Service Revenue loss towards Free Copies (CSA Cost Rate x Free Copy)
                            </td>
                            <td *ngIf="SaleType=='DD'"></td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                            <td>
                               
                            </td>      
                            <td *ngIf="ProfitTag">
                               
                            </td>      
                            <td *ngIf="ProfitTag">
                              
                            </td>      
                            <td *ngIf="ProfitTag" class="text-right"> 
                                {{this.SpraRentalAmcvModel.FreeCopyValue | number : '1.2-2' }}
                            </td>                            
                        </tr>
                        <tr *ngIf="ProfitTag" class="bg-highlight">                            
                            <td colspan="4">
                               <b> Monthly Rent towards Machine</b>
                            </td>
                            <td *ngIf="SaleType=='DD'"></td>
                            <td>
                                
                            </td>
                            <td>
                                
                            </td>
                            <td>
                               
                            </td>      
                            <td *ngIf="ProfitTag">                               
                            </td>      
                            <td *ngIf="ProfitTag">                              
                            </td>      
                            <td *ngIf="ProfitTag">                                 
                            </td>                            
                        </tr>
                        <tr *ngIf="ProfitTag" class="bg-highlight">                            
                            <td colspan="6">
                               Fixed Rent towards M/c Rent less Notional Free Copy (Rs) Per Copy Contract
                            </td>
                            <td *ngIf="SaleType=='DD'"></td>
                            <td>
                               
                            </td>      
                            <td *ngIf="ProfitTag">                               
                            </td>      
                            <td *ngIf="ProfitTag">                              
                            </td>      
                            <td *ngIf="ProfitTag" class="text-right">    
                                {{this.SpraRentalAmcvModel.MonthlyRent - this.SpraRentalAmcvModel.FreeCopyValue | number : '1.2-2' }}                             
                            </td>                            
                        </tr>
                    </tbody>
                </table>
        
            </div>
        </div>

        

    </mat-card-content>
</mat-card>